import React from 'react'
import { ListGroup, ListGroupItem } from 'reactstrap'
import { formatNumber } from '../../../Utils'
import { withTranslation } from 'react-i18next';

const PerKiloItem = ({
    washingAndIroningPerKiloPrice,
    washingPerKiloPrice,
    washingAndIroningSpeedySelected,
    washingAndIroningSpeedyPrice,
    longProcessing,
    t
}) => {
    const canShowExpressLabel = !longProcessing || longProcessing === 0;
    const isWashOnly = (washingPerKiloPrice || 0) > 0;
    const basePrice = isWashOnly ? (washingPerKiloPrice || 0) : (washingAndIroningPerKiloPrice || 0);
    const displayPrice = washingAndIroningSpeedySelected
        ? basePrice + (washingAndIroningSpeedyPrice || 0)
        : basePrice;

    return (
        <ListGroup flush className="shopping-item-section">
            <ListGroupItem className="item-main-header">
                <strong>{t('cart.sections.laundry')}</strong>
            </ListGroupItem>
            <ListGroupItem className="item-button single" active={basePrice > 0}>
                <div className="d-flex item-header-font">
                    <div className="item-header">
                        {isWashOnly ? t('cart.options.washOnly') : t('cart.options.washAndIron')}
                        {washingAndIroningSpeedySelected && canShowExpressLabel ? ` ${t('cart.options.express')}` : ''}
                    </div>
                    <div className="small-price">
                        {formatNumber(displayPrice)}
                    </div>
                </div>
            </ListGroupItem>
        </ListGroup>
    );
}

export default withTranslation()(PerKiloItem)